var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "smart-box grid grid--gap-1", class: _vm.computedClasses },
    [
      _c(
        "rb-banner",
        _vm._b(
          {
            staticClass: "smart-box--banner",
            class: _vm.isVerticalFlip,
            attrs: {
              theme: "light",
              "is-text-layout-horizontal": true,
              "vertical-spacing": "small",
              "cta-mobile-orientation": "vertical",
              "pill-theme": "dark",
              "pill-mobile-position": "top-left",
              "controls-position": "top-right",
              "controls-mobile-position": "top-right",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function () {
                    return [_vm._t("title")]
                  },
                  proxy: true,
                },
                {
                  key: "title_block",
                  fn: function () {
                    return [_vm._t("title_block")]
                  },
                  proxy: true,
                },
                {
                  key: "excerpt",
                  fn: function () {
                    return [_vm._t("excerpt")]
                  },
                  proxy: true,
                },
                {
                  key: "excerpt_block",
                  fn: function () {
                    return [_vm._t("excerpt_block")]
                  },
                  proxy: true,
                },
                {
                  key: "cta_1",
                  fn: function () {
                    return [_vm._t("cta_1")]
                  },
                  proxy: true,
                },
                {
                  key: "cta_2",
                  fn: function () {
                    return [_vm._t("cta_2")]
                  },
                  proxy: true,
                },
                {
                  key: "cta_block",
                  fn: function () {
                    return [_vm._t("cta_block")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          },
          "rb-banner",
          Object.assign({}, _vm.$props, _vm.$attrs),
          false
        )
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid grid--gap-1 smart-box--other_elements",
          class: _vm.isHorizontalFlip,
        },
        _vm._l(_vm.swiperSlides, function (slot, index) {
          return _c(
            "rb-dynamic-grid-smart-box",
            { key: index, attrs: { index: index } },
            [_vm._t("other_elements")],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }